// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PasswordGeneratorController from "./password_generator_controller"
application.register("password-generator", PasswordGeneratorController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
